import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Companies Redux States
import {
  CREATE_AVAILABILITY,
  GET_AVAILABILITY,
  EDIT_AVAILABILITY,
  DELETE_AVAILABILITY,
  UPDATE_AVAILABILITY,
  UPDATE_AVAILABILITY_AGENT,
  UPDATE_AVAILABILITY_SIGNALR,
  GET_AVAILABILITIES,
} from "./actionTypes";
import {
  apiError,
  apiErrorCRUD,
  createdAvailability,
  setAvailability,
  editAvailabilitySuccess,
  loadAvailabilities,
  deleteAvailabilitySuccess,
  updateAvailabilitySuccess,
  updateAvailabilityAgentSuccess,
  updateAvailabilitySignalrSuccess,
  resetUpdateAgent,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getAvailabilities({ payload: { page, qnt, name } }) {
  try {
    const response = yield call(
      axios.get,
      `/availabilities?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(loadAvailabilities(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiErrorCRUD(message));
  }
}

function* createAvailability({ payload: { newFields } }) {
  try {
    const response = yield call(axios.post, `/availabilities`, newFields);
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(createdAvailability(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiErrorCRUD(message));
  }
}
function* getAvailability({ payload: { idAvailability } }) {
  try {
    const response = yield call(
      axios.get,
      `/availabilities${idAvailability && `?id=${idAvailability}`}`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setAvailability(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiErrorCRUD(message));
  }
}

function* editAvailability({ payload: { idAvailability, newFields } }) {
  try {
    const response = yield call(
      axios.patch,
      `/availabilities${idAvailability && `?id=${idAvailability}`}`,
      newFields
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message ? response.data.message : "";
      yield put(editAvailabilitySuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiErrorCRUD(message));
  }
}
function* deleteAvailability({ payload: { availId } }) {
  try {
    const response = yield call(
      axios.delete,
      `/availabilities${availId ? `?id=${availId}` : ""}`
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteAvailabilitySuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiErrorCRUD(message));
  }
}

function* updateAvailability({ payload: { availId, availName } }) {
  try {
    const response = yield call(axios.patch, `/user/status`, availId);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      localStorage.setItem("status", availName);
      let message = response.data.message ? response.data.message : "";
      yield put(updateAvailabilitySuccess(message, availId.availability_id));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 404:
          message = "not found";
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* updateAvailabilityAgent({ payload: { availId, agentId } }) {
  try {
    const data = {
      availability_id: availId,
      agent_id: agentId,
    }
    const response = yield call(axios.patch, `/agent/status`, data);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message ? response.data.message : "";
      yield put(updateAvailabilityAgentSuccess(message));
      yield put(resetUpdateAgent());
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 404:
          message = "not found";
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* updateAvailabilitySignalr({ payload: { status, message, availId } }) {
  try {
    yield put(updateAvailabilitySignalrSuccess(message, availId));
    yield put(resetUpdateAgent())
  } catch (error) {
    console.log(error);
  }
}

export function* watchGetAvailabilities() {
  yield takeEvery(GET_AVAILABILITIES, getAvailabilities);
}

export function* watchCreateAvailability() {
  yield takeEvery(CREATE_AVAILABILITY, createAvailability);
}

export function* watchGetAvailability() {
  yield takeEvery(GET_AVAILABILITY, getAvailability);
}

export function* watchEditAvailability() {
  yield takeEvery(EDIT_AVAILABILITY, editAvailability);
}
export function* watchDeleteAvailability() {
  yield takeEvery(DELETE_AVAILABILITY, deleteAvailability);
}
export function* watchUpdateAvailability() {
  yield takeEvery(UPDATE_AVAILABILITY, updateAvailability);
}
export function* watchUpdateAvailabilityAgent() {
  yield takeEvery(UPDATE_AVAILABILITY_AGENT, updateAvailabilityAgent);
}

export function* watchUpdateAvailabilitySignalr() {
  yield takeEvery(UPDATE_AVAILABILITY_SIGNALR, updateAvailabilitySignalr);
}

function* authSaga() {
  yield all([
    fork(watchGetAvailabilities),
    fork(watchCreateAvailability),
    fork(watchGetAvailability),
    fork(watchEditAvailability),
    fork(watchDeleteAvailability),
    fork(watchUpdateAvailability),
    fork(watchUpdateAvailabilityAgent),
    fork(watchUpdateAvailabilitySignalr)
  ]);
}

export default authSaga;
